import Button from "@elements/button";

interface Props {
    className?: string;
    title: string;
    description?: string;
    hide?: boolean;
    action?: React.ReactNode;
    onAccept: () => void;
}

const CookieBanner: React.FC<Props> = ({ onAccept, hide, title }) => {
    return (
        hide ? null : 
            <div className=" max-w-[1240px] mx-auto w-full  sm:flex-row flex-col  flex items-center px-5 py-3 justify-between ">
                <p className=" font-bold text-sm flex-1 sm:mb-0 mb-2 text-[#333] sm:text-left text-center leading-7">{title}</p>
                <Button className="mx-5 px-2 rounded-lg font-bold text-sm" onClick={onAccept}>
                    Accept cookies
                </Button>
            </div>
    );
};

export default CookieBanner;
